/**
 * Copyright (c) HashiCorp, Inc.
 */

import { hash } from '@ember/helper';
import {
  HdsBadge,
  HdsBadgeSizeValues,
  HdsIcon,
  HdsIconSizeValues,
} from '@hashicorp/design-system-components/components';

import ListItemSection from './section.gts';

import type { TOC } from '@ember/component/template-only';
import type { WithBoundArgs } from '@glint/template';

export interface ListItemTemplateSignature {
  Blocks: {
    default: [
      {
        Section?: typeof ListItemSection;
        Badge?: WithBoundArgs<typeof HdsBadge, 'size'>;
        Icon?: WithBoundArgs<typeof HdsIcon, 'size'>;
        SecondSection?: typeof ListItemSection;
      },
    ];
  };
  Element: HTMLDivElement;
}

const ListItemTemplate: TOC<ListItemTemplateSignature> = <template>
  <div class="cut-list-item-template" ...attributes>
    {{yield (hash Section=ListItemSection)}}

    <div>
      {{yield
        (hash
          Badge=(component HdsBadge size=HdsBadgeSizeValues.Small)
          Icon=(component HdsIcon size=HdsIconSizeValues.Sixteen)
        )
      }}
    </div>

    {{yield (hash SecondSection=ListItemSection)}}
  </div>
</template>;

export default ListItemTemplate;
